import { create } from "zustand";

/**
 * useControleRecebimentoEpiListaFilters
 */

type State = {
  idsGestaoEpi: number[] | null;
  idsFornecedores: number[] | null;
  ca: string | null;
  dataRecebimento: (Date | null)[] | null;
  dataValidade: (Date | null)[] | null;
};

export const initialControleRecebimentoEpiListaState = {
  idsGestaoEpi: null,
  idsFornecedores: null,
  ca: null,
  dataRecebimento: null,
  dataValidade: null,
};

export const useControleRecebimentoEpiListaFilters = create<State>((set, get) => ({
  ...initialControleRecebimentoEpiListaState,
}));